import { breakpoints } from '@etg/wings';
import { css } from '@eti/styles';
import StackedIcon from '../stacked_icon/StackedIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const titleStyles = css`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.4375rem;
`;
export const Title = ({
  children
}) => /*#__PURE__*/_jsx("h3", {
  className: titleStyles,
  children: children
});
const wrapperStyles = theme => css`
  background: ${theme && `${theme.background.main}`};
  background: ${theme && `linear-gradient(90deg, ${theme.background.accent} 0%, ${theme.background.accent} 1.625rem, ${theme.background.main} 1.625rem, ${theme.background.main} 100%)`};
  border-radius: 0.1875rem;
  box-shadow: 0 0 0.5rem rgb(0 0 0 / 12%);
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  padding: 1.25rem 0.625rem;
  position: relative;

  @media (min-width: ${breakpoints._970}) {
    background: ${theme && `linear-gradient(90deg, ${theme.background.accent} 0%, ${theme.background.accent} 2.25rem, ${theme.background.main} 2.25rem, ${theme.background.main} 100%)`};
    padding: 1.25rem 0.75rem;
  }

  [dir='rtl'] & {
    background: ${theme && `linear-gradient(-90deg, ${theme.background.accent} 0%, ${theme.background.accent} 1.625rem, ${theme.background.main} 1.625rem, ${theme.background.main} 100%)`};

    @media (min-width: ${breakpoints._970}) {
      background: ${theme && `linear-gradient(-90deg, ${theme.background.accent} 0%, ${theme.background.accent} 2.25rem, ${theme.background.main} 2.25rem, ${theme.background.main} 100%)`};
    }
  }
`;
export const Wrapper = ({
  children,
  theme,
  ...rest
}) => /*#__PURE__*/_jsx("div", {
  ...rest,
  className: wrapperStyles(theme),
  children: children
});
const buttonStyles = css`
  background: transparent;
  border: 0;
  cursor: pointer;
  padding: 0;
  position: absolute;
  right: 1rem;
  top: 1rem;

  [dir='rtl'] & {
    left: 1rem;
    right: auto;
  }
`;
export const Button = ({
  children,
  ...props
}) => /*#__PURE__*/_jsx("button", {
  ...props,
  className: buttonStyles,
  type: "button",
  children: children
});
const notificationIconStyles = css`
  flex: 0 1 2rem;
  height: 2rem;
  margin-right: 0.625rem;
  width: 2rem;

  @media (min-width: ${breakpoints._970}) {
    flex: 0 1 3rem;
    height: 3rem;
    margin-right: 1.375rem;
    width: 3rem;
  }

  [dir='rtl'] & {
    margin-left: 0.625rem;
    margin-right: 0;

    @media (min-width: ${breakpoints._970}) {
      margin-left: 1.375rem;
      margin-right: 0;
    }
  }
`;
export const NotificationIcon = ({
  icons
}) => /*#__PURE__*/_jsx(StackedIcon, {
  className: notificationIconStyles,
  icons: icons
});
const contentStyles = css`
  flex: 1;
  font-size: 0.875rem;

  ul {
    list-style-position: outside;
    list-style-type: disc;
    overflow-wrap: break-word;
    padding-left: 1rem;
    word-break: normal;

    [dir='rtl'] & {
      padding-left: 0;
      padding-right: 1rem;
    }
  }
`;
export const Content = ({
  children
}) => /*#__PURE__*/_jsx("div", {
  className: contentStyles,
  children: children
});
//# sourceMappingURL=styledComponents.js.map